document.addEventListener("DOMContentLoaded", function () {
  const level2Links = document.querySelectorAll(".x-menu--level-2--link");

  if (level2Links.length > 0) {
    level2Links.forEach(function (link) {
      link.addEventListener("mouseover", function () {
        const dataHandle = link.getAttribute("data-link");
        const level3Container = document.querySelector(
          '.x-menu--level-3--container[data-link="' + dataHandle + '"]'
        );

        if (level3Container) {
          const allLevel3Containers = document.querySelectorAll(
            ".x-menu--level-3--container"
          );
          allLevel3Containers.forEach(function (container) {
            container.style.opacity = "0";
          });

          level3Container.style.opacity = "1";
        }
      });

      link.addEventListener("mouseleave", function () {
        const allLevel3Containers = document.querySelectorAll(
          ".x-menu--level-3--container"
        );
        allLevel3Containers.forEach(function (container) {
          container.style.opacity = "0";
        });
      });
    });
  }
});
